import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Attach JWT from localStorage as Authorization fallback (for cross-domain)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vcard_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== '/login') {
        localStorage.removeItem('vcard_token');
        localStorage.removeItem('vcard_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(e);
  }
);

export function formatApiError(detail) {
  if (detail == null) return '出错了,请重试';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export default api;
